import { Content } from '../../types';

export const kohRongContent: Content = {
  title: 'קו רונג – גן עדן טרופי בקמבודיה',
  imageUrl: 'https://tinyurl.com/koh-rong-wide',
  introduction: `קו רונג (Koh Rong) הוא הגדול והפעיל יותר מבין שני איים סמוכים (Koh Rong ו-Koh Rong Snaloem) שבקמבודיה, אותנטיים במיוחד, המצויים מערבית ליבשה, במזרח מפרץ תאילנד. חופי האי בתוליים לחלוטין, עם מים כחולים/טורקיז וחול לבן ורך - מראות שלא תראו בהרבה מקומות.`,
  sections: [
    {
      title: 'החופים והכפרים',
      content: `הכפר/החוף המרכזי של האי הוא Koh Touch, בו נמצא הרציף שדרכו מגיעים/עוזבים את האי. כאן נמצאים מירב הגסטהאוסים ובתי המלון וכלל שירותי התיירות, שהם אותנטיים, פשוטים, מלאי חיים ומזמינים.

ישנם עוד מספר כפרים וחופים מבודדים יותר על האי, כשהמפורסם מביניהם הוא Long Beach, המשתרע לאורך כ-7 ק"מ ומציע חול לבן ומים בצבע טורקיז מרהיב. בסמוך אליו ניתן למצוא מפל מים עונתי. חוף Coconut Beach מספק אווירה שלווה יותר, בעוד Sok San Beach מציע נופים עוצרי נשימה עם אווירה אותנטית של כפר דייגים.`,
      type: 'text',
    },
    {
      title: 'אטרקציות ופנאי',
      content: `במהלך היום ניתן לצאת לטיולי אופניים, צלילות (כולל קורסים), שנרקולים, דייג ועוד. במהלך הלילה ניתן לצאת לסיור פלנקטונים קסום, כמו גם לבלות בחוף המרכזי באופן אותנטי ושוקק חיים.

קו רונג מציע מגוון רחב של פעילויות, כולל שנורקלינג, צלילה עם שוניות אלמוגים מרשימות, קיאקים, ואפילו טרקים ביער הטרופי המכסה חלק מהאי. חוויה ייחודית נוספת היא התופעה של הפלנקטון הזוהר בלילה – כאשר שוחים במים לאחר רדת החשכה, ניתן לראות אורות כחולים-זרחניים מסביבכם.`,
      type: 'text',
    },
    {
      title: 'לינה ומסעדות',
      content: `קו רונג מציע מגוון רחב של אפשרויות לינה – מבונגלוס פשוטים על החוף ועד ריזורטים יוקרתיים עם נוף ישיר לים. בין המקומות הפופולריים ניתן למצוא את Sok San Beach Resort לאווירה מפנקת ואת Nest Beach Club לחוויה צעירה ותוססת.

בנוגע לאוכל, המסעדות באי מציעות מטבח קמבודי מקומי לצד מאכלים מערביים. מומלץ לנסות את המסעדות לאורך החוף של Koh Touch, שם ניתן ליהנות ממנות טריות של פירות ים על רקע השקיעה.`,
      type: 'text',
    },
    {
      title: 'חנויות ומסעדות באי',
      content: '',
      type: 'image',
      imageUrl: 'https://tinyurl.com/koh-rong-article-1',
    },
    {
      title: 'איך מגיעים?',
      content: `אל האי מגיעים באמצעות שיט בן כ-50 דקות מהעיר הסמוכה סיהנוקוויל וההתניידות ברחבי האי היא באמצעות טוק-טוקים, קטנועים, אופניים, ובין החופים עצמם ניתן להתנייד אף באמצעות Taxi Boat. ישנם מספר מפעילים שמציעים שייט הנמשך בין 45-90 דקות, בהתאם לסוג הסירה. מומלץ להזמין כרטיסים מראש במיוחד בעונה התיירותית.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `קו רונג וקו רונג סנלואם הם שני יעדים קסומים בקמבודיה, וכל אחד מהם מציע חוויה שונה – מהשילוב בין חיי לילה ורוגע בקו רונג ועד השלווה והפסטורליות של קו רונג סנלואם. לא משנה איזה אי תבחרו, החוויה תהיה בלתי נשכחת!`,
      type: 'text',
    },
  ],
};
